import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M15.5 9L15.6716 9.17157C17.0049 10.5049 17.6716 11.1716 17.6716 12C17.6716 12.8284 17.0049 13.4951 15.6716 14.8284L15.5 15"
        stroke="white"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M13.2939 7.16992L11.9999 11.9996L10.7058 16.8292"
        stroke="#F59C53"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M8.50067 9L8.3291 9.17157C6.99577 10.5049 6.3291 11.1716 6.3291 12C6.3291 12.8284 6.99577 13.4951 8.3291 14.8284L8.50067 15"
        stroke="white"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        opacity="0.5"
        d="M12.2451 22C17.768 22 22.2451 17.5228 22.2451 12C22.2451 6.47715 17.768 2 12.2451 2C6.72227 2 2.24512 6.47715 2.24512 12C2.24512 17.5228 6.72227 22 12.2451 22Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M15.7451 9L15.9167 9.17157C17.25 10.5049 17.9167 11.1716 17.9167 12C17.9167 12.8284 17.25 13.4951 15.9167 14.8284L15.7451 15"
        stroke="white"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M13.5391 7.16992L12.245 11.9996L10.9509 16.8292"
        stroke="white"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M8.74579 9L8.57422 9.17157C7.24089 10.5049 6.57422 11.1716 6.57422 12C6.57422 12.8284 7.24089 13.4951 8.57422 14.8284L8.74579 15"
        stroke="white"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Icon;
